<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <h1 class="section-divider-underline">
        {{ $t("evaluationExamination.evaluation") }}
      </h1>
      <div class="row tw-space-y-4">
        <div class="col-12" v-if="model.candidate[0]">
          <label class="form-label col-form-label col-md-4">
            <span>Card Number : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].card_number }}</span
            >
          </label>
          <label class="form-label col-form-label col-md-4">
            <span>Candidate : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].candidate_name_en }}</span
            >
          </label>
          <label class="form-label col-form-label col-md-4">
            <span>Sex : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].sex }}</span
            >
          </label>
          <label class="form-label col-form-label col-md-4">
            <span>Register Date : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].register_date }}</span
            >
          </label>
          <label class="form-label col-form-label col-md-4">
            <span>Phone : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].phone }}</span
            >
          </label>
          <label class="form-label col-form-label col-md-4">
            <span>Skill : </span>
            <span
              class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
              >{{ model.candidate[0].level_skill_name }}</span
            >
          </label>
        </div>
        <div
          class="tw-overflow-y-scroll col-12"
          style="max-height: 65vh; height: 65vh"
        >
          <table class="tw-w-full">
            <thead>
              <tr
                class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
              >
                <th class="tw-pl-2">
                  {{ $t("evaluationExamination.subject") }}
                </th>
                <th class="tw-text-center">
                  {{ $t("evaluationExamination.isPass") }}
                </th>
                <th>{{ $t("evaluationExamination.remark") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(evaluation, index) in evaluations"
                :key="index"
                class="tw-w-full tw-h-10"
              >
                <td class="tw-whitespace-no-wrap tw-pl-2">
                  {{ evaluation.subject_name_en }}
                </td>
                <td class="tw-whitespace-no-wrap tw-text-center">
                  <input type="checkbox" v-model="evaluation.is_passed" />
                </td>
                <td class="tw-whitespace-no-wrap">
                  <input
                    v-model="evaluation.remarks"
                    placeholder="remarks"
                    style="min-width: 90px"
                    class="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "evaluation",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/evaluationExamination", [
      "formViewDatas",
      "edit_data",
    ]),
    evaluations() {
      if (this.model.evaluation_list) {
        return this.model.evaluation_list;
      } else return [];
    },
  },
  methods: {
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
